import { Icon } from './icon.interface';

const IconCheck = ({ height = 24, width = 24, className = '' }: Icon) => (
  <svg className={className} fill="none" height={height} viewBox="0 0 24 24" width={width} xmlns="http://www.w3.org/2000/svg">
    <path d="m3 12 6 6L21 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.125" />
  </svg>
);

export default IconCheck;
